<div class="flex justify-between">
  <button (viewDateChange)="viewDateChange.next($event)"
          [(viewDate)]="viewDate"
          [view]="view"
          mat-raised-button
          mwlCalendarPreviousView>
    <mat-icon svgIcon="mat_outline:arrow_back"></mat-icon>
    Anterior
  </button>
  <div>
    <p class="text-center md:text-2xl px-4 flex items-center">

      <mat-icon (viewDateChange)="viewDateChange.next($event)" [(viewDate)]="viewDate"
                class="mr-2"
                mwlCalendarToday svgIcon="mat_outline:calendar_today"></mat-icon>

      {{ viewDate | calendarDate: view + 'ViewTitle':locale | titlecase }}
    </p>
  </div>
  <button (viewDateChange)="viewDateChange.next($event)"
          [(viewDate)]="viewDate"
          [view]="view"
          mat-raised-button
          mwlCalendarNextView>
    Siguiente
    <mat-icon svgIcon="mat_outline:arrow_forward"></mat-icon>
  </button>
</div>
